var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ve-icon-button', _vm.disabled ? 'disabled' : null],attrs:{"title":_vm.title},on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }